import { formatExamDate } from "@memorang/helpers/date";
import { Trans, useTranslation } from "react-i18next";
import { Pressable } from "react-native";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { AppIcon } from "../AppIcon";
import Box from "../Box";

type Props = {
	examDate?: Date;
	allowChangeExamDate?: boolean;
	toggleShowDatePicker: () => void;
};

export const ExamDateSubtitle = ({
	examDate,
	allowChangeExamDate = true,
	toggleShowDatePicker,
}: Props) => {
	const theme = useAppTheme();
	const { t, i18n } = useTranslation();

	const content = (hovered: boolean) => (
		<Box flexDirection="row" alignItems="center" gap={4}>
			<AppIcon name="calendar-outline" size={24} color={theme.colors.primary} />
			{examDate ? (
				<Text
					variant="titleSmall"
					numberOfLines={1}
					ellipsizeMode="tail"
					style={{ color: theme.colors.onSurfaceVariant }}
				>
					<Trans
						i18nKey="dashboard.header.examInfo.subtitle.examDateWithValue"
						values={{
							date: formatExamDate(examDate, i18n.language, {
								omitCurrentYear: true,
							}),
						}}
						components={{
							date: (
								<Text
									variant="titleSmall"
									style={{
										color: theme.colors.onSurface,
										textDecorationLine: hovered ? "underline" : "none",
									}}
								>
									{""}
								</Text>
							),
						}}
					/>
				</Text>
			) : (
				<Text
					variant="titleSmall"
					numberOfLines={1}
					ellipsizeMode="tail"
					style={{
						color: theme.colors.onSurfaceVariant,
						textDecorationLine: hovered ? "underline" : "none",
					}}
				>
					{t("dashboard.header.examInfo.subtitle.setExamDate")}
				</Text>
			)}
			{hovered ? (
				<AppIcon name="pencil-outline" size={16} color={theme.colors.primary} />
			) : null}
		</Box>
	);

	if (!examDate && !allowChangeExamDate) {
		return null;
	}

	if (!allowChangeExamDate) {
		return content(false);
	}

	return (
		<Pressable
			onPress={toggleShowDatePicker}
			accessibilityLabel={t("commandBar.actions.setExamDate")}
			accessibilityRole="button"
		>
			{(state) => {
				const hovered = "hovered" in state ? Boolean(state.hovered) : false;
				return content(hovered);
			}}
		</Pressable>
	);
};
